/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/ui/WidgetBase'
], function(WidgetBase) {
	/**
	 * The PlaceHolder widget
	 */
	var PlaceHolderWidget = WidgetBase.extend({

		init: function() {
			PlaceHolderWidget.inherited('init', this, arguments);
		}

	});

	return PlaceHolderWidget;
});
